import React from 'react';
import styles from '@/assets/styles/StudyCenter.module.less';
// import Summary from './Summary';
import LeftMenu from '../common/LeftMenu';
import UserInfo, { useUserInfo } from '../common/UserInfo';
import VocabularyList from './Vocabulary/VocabularyList';

const CollectionList: React.FC = () => {
  const userInfo = useUserInfo();
  return <VocabularyList userId={userInfo.userId} userName={userInfo.name} />;
};

const Collections: React.FC = () => {
  return (
    <main className={styles.studyCenterContainer}>
      <LeftMenu />
      <UserInfo title="我的资料">
        <CollectionList />
      </UserInfo>
    </main>
  );
};

export default Collections;
